export default __webpack_public_path__ + "static/foster-banner-bg-5d7af877a8b235bc18e912085923be9f.jpg";